import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signup } from '../actions/userActions';

const SignupPage: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [alert, setAlert] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setAlert('Passwords do not match');
      return;
    } else {
      setAlert('');
      dispatch(signup(name, email, username, password));

      navigate('/open');
    }
  };

  const userLogin = useSelector((state: appState) => state.userLogin);

  const { loading, error, userData } = userLogin;

  useEffect(() => {
    if (userData) {
      navigate('/open');
    }
  }, [navigate, userData]);

  return (
    <div className='signup'>
      <h1>
        Thank you for choosing <span className='primary-color'>EZZE Bank!</span>
      </h1>
      <p>Let's get you set up. Fill out the form below to register.</p>
      <form className='signup-form' onSubmit={submitHandler}>
        <div className='form-control'>
          <label htmlFor='name'>Full Name</label>
          <input
            type='text'
            id='name'
            placeholder='Enter full name'
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='email'>Email</label>
          <input
            type='email'
            id='email'
            placeholder='Enter email address'
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='username'>Username</label>
          <input
            type='text'
            id='username'
            placeholder='Enter a username'
            required
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='password'>Password</label>
          <input
            type='password'
            id='password'
            placeholder='Enter a password'
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className='form-control'>
          <label htmlFor='passwordConfirm'>Confirm Password</label>
          <input
            type='password'
            id='passwordConfirm'
            placeholder='Re-enter password'
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <p className='open-account'>
          Note: You can add 1 account to start with and later add up to a
          maximum of 5 total accounts.
        </p>
        {loading && <p>Loading...</p>}
        {error && <p className='error'>{error}</p>}
        {alert && <p className='error'>{alert}</p>}
        <button type='submit' className='register-btn'>
          Register
        </button>
      </form>
    </div>
  );
};

export default SignupPage;
